/*
 * @prop --background-color: Background color of ghettobox
 */

:host {
  @include base-invert;
  @include button-invert;

  --background-color: #{$colorError60};
  --color: #{$baseInvertColor};
  --richtext-color: var(--color);
}

.stzh-ghettobox {
  position: relative;
  color: var(--color);
  box-shadow: $boxShadowMessage;
  background-color: var(--background-color);

  --stzh-button-secondary-color: #{$colorError60};
  --stzh-button-secondary-background-color: #{$colorWhite90op};

  --stzh-button-secondary-hover-color: #{$colorError60};
  --stzh-button-secondary-hover-background-color: #{$colorWhite};

  --stzh-button-secondary-disabled-color: #{$colorWhite60op};
  --stzh-button-secondary-disabled-background-color: #{$colorWhite40op};

  &__container {
    @include container;
    @include spaceCurve('padding-top', 'large');
    @include spaceCurve('padding-bottom', 'large');
  }

  &__hidden-title {
    @include visuallyhidden;
  }

  &__message {
    @include spaceCurve('gap', 'regular');
    display: flex;
    flex-direction: column;
  }

  &__main-title {
    @include font('title');
    @include fontCurve('h2', 'heading');
    margin: 0;
    color: inherit;

    &:not(:empty) {
      @include spaceCurve('margin-bottom', 'regular');
    }
  }

  &__description {
    @include fontCurve('p1');
    --stzh-base-color: var(--richtext-color);

    &:not(:empty) {
      @include spaceCurve('margin-bottom', 'small');
    }
  }

  &__button {
    display: grid;

    @include mq($from: small) {
      justify-content: start;
    }
  }

  &__close {
    position: absolute;
    top: 0;
    right: 0;

    @include mq($from: small) {
      top: 10px;
      right: 10px;
    }
  }
}
